<template>
  <div class="view">Redirecting...</div>
</template>

<script>
export default {
    name: 'Logout',
    mounted()
    {
        this.logout()
    }

}
</script>